import React from "react";
import styled from "styled-components";
import { primaryColor } from "../constants/colors";

const Spinner = ({ size = 50 }) => {
  return (
    <SpinnerWrapper size={size}>
      <div className="spinner"></div>
    </SpinnerWrapper>
  );
};

export default Spinner;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    border: 5px solid #f3f3f3; /* Light gray */
    border-top: 5px solid ${primaryColor}; /* Blue */
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
